import { useTranslation } from 'react-i18next';

const StructuredData = () => {
  const { t, i18n } = useTranslation();

  // Only show structured data for English, as the app is primarily English
  if (i18n.language !== 'en') {
    return null;
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": t('faq.q1.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q1.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q2.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q2.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q3.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q3.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q4.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q4.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q5.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q5.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q6.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q6.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q7.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q7.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q8.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q8.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q9.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q9.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q10.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q10.answer')
        }
      }
    ]
  };

  const appSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "SuperMenuBar",
    "alternateName": ["SuperMenuBar Menu Bar Utility", "SuperMenuBar App", "Mac Productivity App", "Mac Menu Bar Tool", "Mac Pomodoro Timer", "Mac Keep Awake App", "Mac Calendar Widget", "Mac Camera Preview"],
    "description": t('hero.description'),
    "url": "https://macsuperapp.com/",
    "applicationCategory": "ProductivityApplication",
    "operatingSystem": "macOS",
    "screenshot": "https://macsuperapp.com/app_screenshots/main_app.webp",
    "author": {
      "@type": "Organization",
      "name": "SuperMenuBar"
    },
    "inLanguage": i18n.language,
    "featureList": [
      t('features.pomodoroTimer.description'),
      t('features.keepAwake.description'),
      t('features.quickCalendar.description'),
      t('features.cameraPreview.description'),
      t('features.microphoneControls.description'),
      t('features.menuBarIntegration.description')
    ],
    "softwareRequirements": "macOS 12.0+",
    "releaseNotes": t('hero.description')
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(appSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </>
  );
};

export default StructuredData;